import type { JSX, ReactNode } from 'react';
import { Heading } from '../Heading';
import { Stack } from '../Stack';

export type ModalCalloutsProps = {
  /**
   * The content to be displayed in the modal callout.
   */
  children?: ReactNode;
};

export const ModalCallouts = ({ children }: ModalCalloutsProps) => {
  return (
    <Stack
      direction="horizontal"
      gap="space-08"
    >
      {children}
    </Stack>
  );
};

ModalCallouts.displayName = 'ModalCallouts';

type ModalCalloutProps = {
  title: string;
  image: JSX.Element;
  /**
   * The content to be displayed in the modal callout.
   */
  children?: ReactNode;
};

export const ModalCallout = ({ title, image, children }: ModalCalloutProps) => {
  return (
    <Stack direction="vertical">
      {image}
      <Heading variant="heading4">{title}</Heading>
      {children}
    </Stack>
  );
};

ModalCallout.displayName = 'ModalCallout';
